// @flow
/**
 * Redux action type dispatched in order to toggle screenshot captures.
 *
 * {
 *      type: SET_SCREENSHOT_CAPTURE
 * }
 */
export const SET_SCREENSHOT_CAPTURE = 'SET_SCREENSHOT_CAPTURE';
